var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { MultiDayView, defaultProps as multiDayViewDefaultProps } from '../day/MultiDayView';
import { dayViewTitle, messages } from '../../messages';
/**
 * Represents the KendoReact [DayView]({% slug day_view_scheduler %}) Component.
 */
export var DayView = function (props) { return React.createElement(MultiDayView, __assign({}, props)); };
var defaultProps = {
    name: 'day',
    title: function (localization) { return localization.toLanguageString(dayViewTitle, messages[dayViewTitle]); },
    dateRange: multiDayViewDefaultProps.dateRange,
    step: 1,
    numberOfDays: 1,
    slotDuration: 60,
    slotDivisions: 2,
    selectedDateFormat: '{0:D}',
    selectedShortDateFormat: '{0:d}'
};
DayView.defaultProps = defaultProps;
DayView.displayName = 'KendoReactSchedulerDayView';
//# sourceMappingURL=DayView.js.map